import { z } from "zod";
import { idempotencyKeySchema } from "./common.js";

/**
 * The mixin shape every mutating procedure's input embeds. The
 * middleware lifts the `idempotencyKey` field off the input on its
 * way through; the procedure body sees the rest of the input.
 */
export const idempotencyEnvelopeSchema = z.object({
  idempotencyKey: idempotencyKeySchema,
});
export type IdempotencyEnvelope = z.infer<typeof idempotencyEnvelopeSchema>;
